/**
 * 쿼리 키 팩토리
 *
 * TanStack Query 쿼리 키 일관성 보장
 * shared 레이어: config, workspace-pkg만 import 가능
 */

export interface QueryKeyFactory {
  /** 도메인 전체 키 (모든 캐시 무효화 등) */
  all: readonly [string];
  /** 목록 타입 키 */
  lists: readonly [string, "list"];
  /** 필터/파라미터 포함 목록 키 */
  list: (params: unknown) => readonly [string, "list", unknown];
  /** 상세 타입 키 */
  details: readonly [string, "detail"];
  /** ID 기반 상세 키 */
  detail: (id: string | number) => readonly [string, "detail", string | number];
}

/**
 * 도메인별 쿼리 키 팩토리 생성
 *
 * @example
 * const productKeys = createQueryKeys('products');
 * // productKeys.all          → ['products']
 * // productKeys.lists        → ['products', 'list']
 * // productKeys.list({...})  → ['products', 'list', {...}]
 * // productKeys.details      → ['products', 'detail']
 * // productKeys.detail('1')  → ['products', 'detail', '1']
 */
export function createQueryKeys(domain: string): QueryKeyFactory {
  return {
    all: [domain] as const,
    lists: [domain, "list"] as const,
    list: (params: unknown) => [domain, "list", params] as const,
    details: [domain, "detail"] as const,
    detail: (id: string | number) => [domain, "detail", id] as const,
  };
}
